import React, { useState, useEffect, useMemo } from 'react'

import { Header, HeaderMobile, AuthHeader } from '@paypalcorp/developeruikit'
import { headerLinksWithServerSdk as originalHeaderLinks } from '../../../content/homeContent'
import { useWindowSize } from '../../../hooks/useWindowSize/useWindowSize'
import { Container, Row } from '@paypalcorp/pp-react-grid'
import { useLocation } from '@reach/router'
import { useApplicationContext } from '../../../provider'
import { removeGAParam } from '../../pp-react-wrappers'

const UiKitHeaderContainer = (user) => {
  const userLoggedIn = user && user.user.loggedIn
  const [SearchModule, setSearchModule] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const windowSize = useWindowSize()
  const location = useLocation()

  const { experiments, elmoData } = useApplicationContext()
  const isAlgoliaSearch =
    experiments.aiSearch === 'Trmt_Developer_AI_Search' ||
    experiments.aiSearch_acctID === 'Trmt_Developer_AI_Search_AcctID'
  let headerMargin = 60
  // Create modified headerLinks based on experiment assignment
  const headerLinksWithServerSdk = useMemo(() => {
    // If not in treatment or no experiment data, return original links
    if (!elmoData || elmoData.tcm_homepage !== 'Trmt_test_cards_homepage') {
      return originalHeaderLinks
    }

    // Clone the original header links to avoid modifying the imported constant
    const updatedLinks = JSON.parse(JSON.stringify(originalHeaderLinks))

    // Find the Tools section
    const toolsSection = updatedLinks.find(
      (section) => section.label === 'Tools',
    )
    if (toolsSection && toolsSection.items) {
      // Find the Credit card generator item
      const creditCardItem = toolsSection.items.find(
        (item) => item.label === 'Credit card generator',
      )
      if (creditCardItem) {
        // Update the URL to point to /test-card-manager
        creditCardItem.url = '/test-card-manager/'
      }
    }

    return updatedLinks
  }, [elmoData])

  if (location?.pathname !== '/home') {
    headerMargin = 70
  }

  const authLinks = [
    {
      label: 'Go to Dashboard',
      url: '',
      items: [
        {
          label: 'Business Dashboard',
          url: 'https://www.paypal.com/myaccount/summary',
        },
        {
          label: 'Developer Dashboard',
          url: 'https://developer.paypal.com/dashboard/',
        },
      ],
    },
    {
      label: 'Help',
      url: 'https://www.paypal.com/smarthelp/home',
    },
  ]

  const authDropdown = [
    {
      label: 'Dashboard',
      url: '/dashboard/',
    },
    {
      label: 'My Account',
      url: '/developer/accountStatus/',
    },
    {
      label: 'Logout',
      url: 'https://www.paypal.com/signout?returnUri=https%3A%2F%2Fdeveloper.paypal.com%2Fhome%2F',
    },
  ]

  useEffect(() => {
    if (typeof window !== `undefined`) {
      setSearchModule(require('@paypalcorp/developersearchui'))
    }
  }, [])

  const fptiData = typeof window !== `undefined` && window.fpti

  const recordAnalytics = () => {
    if (fptiData && window.PAYPAL?.analytics?.instance) {
      const eventNameSuffix = isOpen ? 'closed' : 'shown'
      const eventName = `devexp_${window.fpti.page.replace(
        /[-:]/g,
        '_',
      )}_search_modal_${eventNameSuffix}`

      window.PAYPAL.analytics.instance.record({
        data: {
          ...fptiData,
          component: 'devdiscoverynodeweb',
          space_key: 'SKEXJE',
          event_name: eventName,
          e: 'cl',
          page_name: `${window.fpti.page.replace(/[-:]/g, '_')}`,
          pu: removeGAParam(window.location.href),
        },
      })
    }
  }

  const handleShowSearchModal = () => {
    setIsOpen((prev) => !prev)
    recordAnalytics()
  }
  const handleCloseModal = () => {
    setIsOpen(false)
    recordAnalytics()
  }

  const auth = {
    status: userLoggedIn ? 'logged-in' : 'logged-out',
    firstName: user.user.firstName ? user.user.firstName : '',
    lastName: user.user?.lastName ? user.user.lastName : '',
    userName: user.user?.username ? user.user?.username : '',
  }
  const headerFromUiKit = (
    <Container>
      <Row>
        <div
          className="outerHeaderWrapper"
          style={
            userLoggedIn ? { marginTop: `${headerMargin}px`, zIndex: 1 } : {}
          }
        >
          <Header
            links={headerLinksWithServerSdk}
            children={
              SearchModule &&
              (!isAlgoliaSearch ? (
                <SearchModule.Search
                  onOpen={handleShowSearchModal}
                  onClose={handleCloseModal}
                  clientFptiProps={{
                    component: 'devdocs',
                    space_key: 'SKEXJE',
                  }}
                />
              ) : (
                <SearchModule.AlgoliaSearch
                  fptiOptions={{ component: 'devdocs', space_key: 'SKEXJE' }}
                />
              ))
            }
            user={user}
            location={{ href: location.pathname }}
            auth={auth}
            hasSignUpButton={true}
            signUpLink=""
          />
        </div>
      </Row>
    </Container>
  )

  return (
    <>
      {windowSize.width <= 1300 && (
        <div className="mobileMenu">
          <HeaderMobile
            links={headerLinksWithServerSdk}
            children={
              SearchModule &&
              (!isAlgoliaSearch ? (
                <SearchModule.Search
                  onOpen={handleShowSearchModal}
                  onClose={handleCloseModal}
                  clientFptiProps={{
                    component: 'devdocs',
                    space_key: 'SKEXJE',
                  }}
                />
              ) : (
                <SearchModule.AlgoliaSearch
                  indexName={{
                    PayPal: 'Prod_PayPal_DevEx_V1',
                    Braintree: 'BTDOCS_BTDOCSNODEWEB',
                  }}
                  fptiOptions={{ component: 'devdocs', space_key: 'SKEXJE' }}
                />
              ))
            }
            user={{
              ...(user, user.user),
              auth,
              links: {
                items: [
                  {
                    label: 'Dashboard',
                    url: 'https://developer.paypal.com/dashboard/',
                  },
                  {
                    label: 'My Account',
                    url: 'https://developer.paypal.com/developer/accountStatus/',
                  },
                  {
                    label: 'Log Out',
                    url: 'https://www.paypal.com/signout?returnUri=https%3A%2F%2Fdeveloper.paypal.com%2Fhome&_ga=1.261079885.1562070675.1697895797',
                  },
                ],
              },
            }}
            location={{ href: location.pathname }}
            hasSignUpButton={true}
            signUpLink=""
          />
        </div>
      )}
      {windowSize.width > 1300 && (
        <>
          {userLoggedIn ? (
            <div className="authHeaderHomePage">
              <AuthHeader
                links={authLinks}
                authDropdown={authDropdown}
                auth={auth}
              />
              <div>{headerFromUiKit}</div>
            </div>
          ) : (
            <div>{headerFromUiKit}</div>
          )}
        </>
      )}
    </>
  )
}

export default UiKitHeaderContainer
